import {DocumentFormProps} from "./DocumentForm";
import {FieldInput} from "@kroschke/react-ui";

function DocumentFormDefault({
                                 disabled,
                                 value,
                                 onBlur,
                                 validation,
                                 onChange
                             }: DocumentFormProps) {
    return <>
        <div className={"columns"}>
            <div className={"column is-half"}>
                <FieldInput
                    disabled={true}
                    label={"Dokumenten-Id"}
                    required={true}
                    value={value.documentId}
                    help={validation.documentId}
                    invalid={Boolean(validation.documentId)}
                    onBlur={() => !disabled && onBlur()}
                    onChange={documentID => {
                        onChange({
                            ...value,
                            documentId: documentID
                        })
                    }}
                />
            </div>
            <div className={"column is-half"}>
                <FieldInput
                    disabled={disabled}
                    label={"Position"}
                    required={true}
                    value={`${value.position}`}
                    help={validation.position}
                    invalid={Boolean(validation.position)}
                    onBlur={() => !disabled && onBlur()}
                    onChange={position => {
                        onChange({
                            ...value,
                            position: parseInt(position) || 0
                        })
                    }}
                />
            </div>
        </div>
    </>
}

export {
    DocumentFormDefault
}
